<template>
  <div class="extra-info mt-1 text-xs">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
@use 'sass:color';

@use 'assets/css/variables';

.extra-info {
  color: color.mix(variables.$main-gray-color, white, 60%);

  > :deep(div) {
    align-items: center;
    border-bottom: 1px dotted color.mix(variables.$main-gray-color, white, 20%);
    display: flex;
    padding: 4px 0;

    &:last-child {
      border-bottom: none;
    }

    > svg {
      margin-right: .5em;
      width: 1.25em;
    }

    a:not(:hover) {
      color: inherit;
    }
  }
}
</style>
